// extracted by mini-css-extract-plugin
module.exports = {"formButton":"FormButton_formButton__22C1Y","theme1":"FormButton_theme1__ATfEn","theme2":"FormButton_theme2__2fmS1"};